<template>
  <!-- TODO THIS COMPONENT IS NOT READY FOR PRODUCTION, PLEASE TEST ME END REFACT ME !!! -->
  <div id="my_bets_cashout_v2">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div v-if="getAuthenticated">
      <div v-if="loading">
        <v-progress-linear
          indeterminate
          color="primary darken-2"
        ></v-progress-linear>
      </div>
      <v-sheet :color="`grey darken-2`" class="pa-3" v-if="skeleton_loader">
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="card"
        ></v-skeleton-loader>
      </v-sheet>

      <div
        v-for="(bet, index) in getMyBetsCashout"
        :key="bet._id"
        class="cashout_single_bet"
        @click="openDetail(bet)"
        :title="$t('viewBetDetail')"
        v-if="getMyBetsCashout.length > 0"
      >
        <div :class="['single-bet', bet.cashoutAvailable ? 'cashout' : '']">
          <div class="info-bet">
            <div class="flex d-flex-center d-flex-center-all">
              <div class="type">
                {{ $t(bet.type) }}
                <span
                  class="label-live-mybet"
                  v-if="bet.bet_context == 'live'"
                  >{{ $t('live') }}</span
                >
              </div>
              <div class="date">
                {{ new Date(bet.created_at).toLocaleString() }}
              </div>
            </div>
            <div class="flex d-flex-center d-flex">
              <div class="amount">
                {{ $t('amount') }}
                {{
                  bet.currencySymbol +
                  ' ' +
                  parseFloat(bet.amount_real).toFixed(2)
                }}
              </div>
              <div
                class="result"
                v-if="bet.winning_real"
                :title="$t('winning')"
              >
                {{
                  bet.currencySymbol +
                  ' ' +
                  parseFloat(bet.winning_real).toFixed(2)
                }}
              </div>
              <div
                class="result"
                v-else
                :title="$t('potential') + ' ' + $t('winning')"
              >
                {{ getWinning(bet) }}
              </div>
              <div class="icon">
                <span
                  v-if="bet.result == 'pending'"
                  class="list-pending result-icon"
                  :title="$t(bet.result).toUpperCase()"
                >
                  <div class="circle-pending"></div>
                </span>
                <span
                  v-if="bet.result == 'lose'"
                  class="red--text result-icon"
                  :title="$t(bet.result).toUpperCase()"
                >
                  <v-icon small color="red">mdi-close-circle</v-icon>
                </span>
                <span
                  v-if="bet.result == 'win'"
                  class="green--text result-icon"
                  :title="$t(bet.result).toUpperCase()"
                >
                  <v-icon small color="green"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                </span>
                <span
                  v-if="bet.result == 'void'"
                  class="blue--text result-icon"
                  :title="$t(bet.result).toUpperCase()"
                >
                  <v-icon small color="blue">mdi-alert-circle</v-icon>
                </span>
              </div>
            </div>

            <div class="flex d-flex-center d-flex">
              <div class="cashout-container">
                <!-- Cashout available -->
                <button
                  class="cashout_preview"
                  v-if="bet.cashoutAvailable && bet.cashoutValue > 0"
                  :disabled="bet.isCheckingCashout || bet.isProcessingCashout"
                >
                  {{ $t('cashout.cashout') }}: {{ getSettings.currencySymbol }}
                  {{ formatNumber(bet.cashoutValue) }}
                </button>

                <!-- Loading -->
                <button
                  class="cashout_preview loading-state"
                  v-if="bet.isCheckingCashout"
                  disabled
                >
                  <v-progress-circular
                    indeterminate
                    size="16"
                    width="2"
                    color="white"
                    class="mr-2"
                  ></v-progress-circular>
                  <span>{{ $t('cashout.checkingStatus') }}</span>
                </button>

                <!-- Cashout non available -->
                <!-- Cashout not available (always the same, no distinction, always greyed!) -->
                <button
                  class="cashout_preview unavailable-state"
                  v-if="!bet.cashoutAvailable && !bet.isCheckingCashout"
                  disabled
                >
                  {{ $t('cashout.notAvailable') }}
                </button>
              </div>
            </div>
          </div>
          <div class="actions">
            <v-icon dense>mdi-chevron-right</v-icon>
          </div>
        </div>
      </div>

      <div v-if="getCashoutPagination.totalPages > 1" class="mybets-pagination">
        <button
          :disabled="currentPage === 1"
          @click="goToPage(currentPage - 1)"
          aria-label="Previous"
        >
          &lt;
        </button>
        <button
          v-for="page in getCashoutPagination.totalPages"
          :key="page"
          @click="goToPage(page)"
          :class="{ active: page === currentPage }"
          aria-label="Page"
        >
          {{ page }}
        </button>
        <button
          :disabled="currentPage === getCashoutPagination.totalPages"
          @click="goToPage(currentPage + 1)"
          aria-label="Next"
        >
          &gt;
        </button>
      </div>

      <div v-if="!loading && getMyBetsCashout.length === 0">
        {{ $t('noBetsFound') }}
      </div>
    </div>
    <div v-else class="message">
      {{ $t('loginMyBets') }}
    </div>

    <v-dialog
      v-model="dialog"
      width="75%"
      content-class="modal-on-top"
      :overlay-opacity="0.9"
      v-if="this.dialog && !getModalIdle"
    >
      <v-card v-if="checkIsMobile()" elevation="5" tile>
        <v-overlay :value="overlay_dialog_betlist_detail">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-toolbar flat dark color="black">
          <v-toolbar-title
            class="title-mybet text-center"
            style="text-transform: uppercase; font-size: 12px !important"
            >{{ $t('bet') }} {{ $t('code') }} :
            {{ betToShow.code }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-title>
          <span class="mybet-col-sx"
            >{{ $t(betToShow.type) }}
            <small>({{ getDetailMyBets.odds.length }})</small></span
          >
          <v-spacer></v-spacer>
          <span class="mybet-col-sx">{{
            new Date(betToShow.created_at).toLocaleString()
          }}</span>
        </v-card-title>

        <v-divider class="mx-4"></v-divider>

        <v-list>
          <v-list-item
            v-for="(odd, index) in getDetailMyBets.odds"
            :key="index"
            style="
              border-bottom: 1px solid rgb(57, 57, 57);
              margin: 0 15px;
              padding: 0px;
            "
          >
            <v-list-item-content>
              <div class="xs12">
                <small style="font-size: 12px; color: #a1a1a1">
                  {{
                    new Date(odd.time).toLocaleDateString('en-GB', {
                      month: 'numeric',
                      day: 'numeric',
                    })
                  }}
                  {{
                    new Date(odd.time).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                  }}
                </small>
                <div
                  style="
                    margin-right: 0px;
                    max-height: 20px;
                    max-width: 20px;
                    position: absolute;
                    right: 0px;
                    top: 0px;
                  "
                >
                  <v-col xs="1" class="text-center">
                    <div
                      v-if="betToShow.cashout && !odd.result"
                      :title="$t('cashout')"
                    >
                      <v-icon small color="blue">mdi-alert-circle</v-icon>
                    </div>
                    <div
                      v-if="betToShow.cashout && odd.result"
                      :title="$t('win')"
                    >
                      <v-icon small color="green"
                        >mdi-checkbox-marked-circle</v-icon
                      >
                    </div>
                    <div
                      v-if="!betToShow.cashout && odd.result == undefined"
                      :title="$t('pending')"
                    >
                      <div
                        class="circle-pending"
                        style="margin: 4px auto"
                      ></div>
                    </div>
                    <div
                      v-else-if="!betToShow.cashout && odd.void"
                      :title="$t('void')"
                    >
                      <v-icon small color="blue">mdi-alert-circle</v-icon>
                    </div>
                    <div
                      v-else-if="!betToShow.cashout && odd.cancelled"
                      :title="$t('cancelled')"
                    >
                      <v-icon small color="yellow">mdi-alert-circle</v-icon>
                    </div>
                    <div
                      v-else-if="!betToShow.cashout && odd.result"
                      :title="$t('win')"
                    >
                      <v-icon small color="green"
                        >mdi-checkbox-marked-circle</v-icon
                      >
                    </div>
                    <div
                      v-else-if="!betToShow.cashout && !odd.result"
                      :title="$t('lose')"
                    >
                      <v-icon small color="red">mdi-close-circle</v-icon>
                    </div>
                    <div
                      v-if="!betToShow.cashout && odd.half_won"
                      :title="$t('halfWon')"
                    >
                      <v-icon small color="green">mdi-star-half</v-icon>
                    </div>
                    <div
                      v-else-if="!betToShow.cashout && odd.half_lost"
                      :title="$t('halfLost')"
                    >
                      <v-icon small color="red">mdi-star-half</v-icon>
                    </div>
                  </v-col>
                </div>
              </div>
              <div class="xs12">
                <small style="font-size: 12px; color: #a1a1a1">
                  {{ odd.category.name
                  }}<v-icon x-small style="color: #a1a1a1"
                    >mdi-chevron-right</v-icon
                  >{{ odd.tournament.name }}
                </small>
              </div>
              <div
                class="xs12"
                style="padding-top: 5px; padding-bottom: 5px; font-size: 16px"
              >
                <small>
                  {{
                    odd.event_description != null
                      ? odd.event_description
                      : odd.tournament.name
                  }}
                </small>
              </div>
              <small style="font-size: 11px; color: #a1a1a1">
                <span>{{ odd.outcome_alias || odd.outcome_name }}</span
                ><span>
                  ( {{ odd.market_name }}
                  {{ getSpecifiers(odd.market_unique_id) }})
                </span>
              </small>
            </v-list-item-content>
            <v-list-item-action>
              <small style="font-size: 11px; text-align: right">
                <br />
                <span
                  v-if="
                    betToShow.status != 'finished' &&
                    odd.show_time &&
                    !odd.match_result
                  "
                  class="yellow--text"
                  >&nbsp;{{ odd.result_actual_home }} -
                  {{ odd.result_actual_away }}</span
                >
                &nbsp;<v-icon
                  v-if="
                    betToShow.status != 'finished' &&
                    odd.show_time &&
                    odd.time_actual >= 0 &&
                    !odd.match_result
                  "
                  x-small
                  >mdi-timer</v-icon
                >&nbsp;<span
                  v-if="
                    betToShow.status != 'finished' &&
                    !odd.match_result &&
                    odd.time_actual != '' &&
                    odd.time_actual >= 0
                  "
                  >{{ parseFloat(odd.time_actual).toFixed(2) }}</span
                >
                <span
                  v-if="
                    betToShow.status != 'finished' &&
                    odd.show_time &&
                    odd.time_actual >= 0 &&
                    !odd.match_result
                  "
                  class="blink_me"
                  >'</span
                >
                <br />
                <span v-if="odd.match_result"> [{{ odd.match_result }}] </span>
                <span v-else>
                  {{ odd.outcome_odd_value | odds_type_filter }}
                </span>
              </small>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-list-item dense style="font-size: 12px; color: #a1a1a1">
          <v-list-item-content>
            {{ $t('amount') }}
          </v-list-item-content>
          <v-list-item-action>
            {{
              betToShow.currencySymbol +
              ' ' +
              parseFloat(betToShow.amount_real).toFixed(2)
            }}
          </v-list-item-action>
        </v-list-item>

        <v-list-item dense style="font-size: 12px; color: #a1a1a1">
          <v-list-item-content>
            {{ $t('potential') }} {{ $t('winning') }}
          </v-list-item-content>
          <v-list-item-action>
            {{ getWinning(betToShow) }}
          </v-list-item-action>
        </v-list-item>

        <v-list-item dense style="font-size: 12px; color: #a1a1a1">
          <v-list-item-content>
            {{ $t('bets.status') }}
          </v-list-item-content>
          <v-list-item-action>
            <div
              class="icon"
              :style="betToShow.result == 'pending' ? 'display: flex' : ''"
            >
              <span
                v-if="betToShow.result == 'pending'"
                class="list-pending result-icon"
                :title="$t(betToShow.result)"
                style="display: flex"
              >
                <div class="circle-pending" style="margin: 5px 5px"></div>
              </span>
              <span
                v-if="betToShow.result == 'lose'"
                class="red--text result-icon"
                :title="$t(betToShow.result)"
              >
                <v-icon small color="red">mdi-close-circle</v-icon>
              </span>
              <span
                v-if="betToShow.result == 'win'"
                class="green--text result-icon"
                :title="$t(betToShow.result)"
              >
                <v-icon small color="green">mdi-checkbox-marked-circle</v-icon>
                <small class="light-green--text" v-if="betToShow.cashout"
                  >(cashout)</small
                >
              </span>
              <span
                v-if="betToShow.result == 'void'"
                class="blue--text result-icon"
                :title="$t(betToShow.result)"
              >
                <v-icon small color="blue">mdi-alert-circle</v-icon>
              </span>
            </div>
          </v-list-item-action>
        </v-list-item>

        <v-list-item dense style="font-size: 12px; color: #a1a1a1">
          <v-list-item-content>
            {{ $t('betCreationDate') | capitalize }}
          </v-list-item-content>
          <v-list-item-action>
            {{ new Date(betToShow.created_at).toLocaleString() }}
          </v-list-item-action>
        </v-list-item>

        <v-divider class="mx-4"></v-divider>

        <v-btn
          v-if="betToShow.cashoutAvailable && betToShow.cashoutValue > 0"
          class="btn-cashout-mobile"
          rounded
          color="#a0c528"
          dark
          @click="processCashout(betToShow)"
        >
          {{ $t('cashout.cashout') }}: {{ betToShow.currencySymbol }}
          {{ parseFloat(betToShow.cashoutValue).toFixed(2) }}
        </v-btn>

        <!-- Loading -->

        <v-btn
          v-if="betToShow.isCheckingCashout"
          class="btn-cashout-mobile"
          rounded
          color="#a0c528"
          dark
        >
          <v-progress-circular
            indeterminate
            size="16"
            width="2"
            color="white"
            class="mr-2"
          >
          </v-progress-circular>
          <span>{{ $t('cashout.checkingStatus') }}</span>
        </v-btn>

        <!-- Cashout non available -->

        <v-btn
          v-if="!betToShow.cashoutAvailable && !betToShow.isCheckingCashout"
          class="btn-cashout-mobile"
          rounded
          color="#a0c528"
          dark
        >
          <span v-if="betToShow.cashoutTemporarilyUnavailable">
            {{ $t('cashout.notAvailable') }}
          </span>
          <span v-else>
            {{ $t('cashout.notAvailable') }}
          </span>
        </v-btn>

        <!--        <v-list-item style="font-size: 12px;color: #a1a1a1;">-->
        <!--          <v-list-item-content>-->
        <!--            {{$t('winning')}}-->
        <!--          </v-list-item-content>-->
        <!--          <v-list-item-action>-->

        <!--            <v-btn style="font-size: 12px" v-if="(cashout > 0 || cashout_prematch > 0) && !betToShow.cashout"-->
        <!--                   class="btn-cashout"-->
        <!--                   rounded-->
        <!--                   color="#a0c528"-->
        <!--                   dark-->
        <!--                   @click="getDialogCashout((cashout > 0 ) ? parseFloat(cashout).toFixed(2) : (cashout_prematch > 0 ) ? parseFloat(cashout_prematch).toFixed(2) : '', getWinning(betToShow), betToShow.currencySymbol)"-->
        <!--            >-->
        <!--              Cashout: {{ betToShow.currencySymbol}} {{ (cashout > 0 ) ? parseFloat(cashout).toFixed(2) : (cashout_prematch > 0 ) ? parseFloat(cashout_prematch).toFixed(2) : '' }}-->
        <!--            </v-btn>-->

        <!--            <span v-else>-->
        <!--            {{ (betToShow.winning_real) ? betToShow.currencySymbol + ' ' + parseFloat(betToShow.winning_real).toFixed(2) : betToShow.currencySymbol + ' 0.00'}}-->
        <!--            </span>-->
        <!--          </v-list-item-action>-->
        <!--        </v-list-item>-->
        <v-divider class="mx-4"></v-divider>
        <v-card-actions style="padding-bottom: 20px; padding-top: 20px">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="7" md="5" lg="4" xl="3">
              <v-btn
                color="black"
                dark
                class="mx-auto my-0"
                block
                @click="dialog = false"
              >
                {{ $t('close') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>

      <v-card v-if="!checkIsMobile()">
        <v-overlay :value="overlay_dialog_betlist_detail">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card-title class="text-h6 lighten-2 text-uppercase">
          <span class="title-mybet">
            {{ $t('bet') }} {{ $t('code') }} : {{ betToShow.code }}</span
          >
        </v-card-title>

        <v-card-text>
          <v-container class="bg-bet-detail mt-4 mb-6">
            <v-row>
              <v-col cols="12" md="6" sm="12" xs="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="mybet-col-sx">{{ $t('type') }}</td>
                        <td class="mybet-col-dx">{{ $t(betToShow.type) }}</td>
                      </tr>
                      <tr>
                        <td class="mybet-col-sx">
                          {{ $t('bets.code') | capitalize }}
                        </td>
                        <td class="mybet-col-dx">
                          <span> {{ betToShow.code }}</span>
                          <v-icon
                            class="ml-2"
                            v-if="
                              betToShow.result !== 'cancelled' &&
                              betToShow.status !== 'review'
                            "
                            @click="printBet(betToShow.code)"
                            :title="$t('print')"
                          >
                            mdi-printer
                          </v-icon>
                          <v-icon
                            class="ml-2"
                            @click="rebet(betToShow.odds)"
                            :title="$t('rebet')"
                            v-if="betToShow.result == 'pending'"
                            >mdi-backup-restore
                          </v-icon>
                        </td>
                      </tr>
                      <tr>
                        <td class="mybet-col-sx">
                          {{ $t('betCreationDate') | capitalize }}
                        </td>
                        <td class="mybet-col-dx">
                          {{ new Date(betToShow.created_at).toLocaleString() }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12" md="6" sm="12" xs="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="mybet-col-sx">{{ $t('amount') }}</td>
                        <td class="mybet-col-dx">
                          {{
                            betToShow.currencySymbol +
                            ' ' +
                            parseFloat(betToShow.amount_real).toFixed(2)
                          }}
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <td class="mybet-col-sx">
                          {{ $t('potential') }} {{ $t('winning') }}
                        </td>
                        <td class="mybet-col-dx">
                          {{ getWinning(betToShow) }}
                        </td>
                        <td>
                          <v-btn
                            v-if="
                              betToShow.cashoutAvailable &&
                              betToShow.cashoutValue > 0
                            "
                            class="btn-cashout"
                            rounded
                            color="#a0c528"
                            dark
                            @click="processCashout(betToShow)"
                          >
                            {{ $t('cashout.cashout') }}:
                            {{ betToShow.currencySymbol }}
                            {{ parseFloat(betToShow.cashoutValue).toFixed(2) }}
                          </v-btn>

                          <!-- Loading -->

                          <v-btn
                            v-if="betToShow.isCheckingCashout"
                            class="btn-cashout"
                            rounded
                            color="#a0c528"
                            dark
                          >
                            <v-progress-circular
                              indeterminate
                              size="16"
                              width="2"
                              color="white"
                              class="mr-2"
                            >
                            </v-progress-circular>
                            <span>{{ $t('cashout.checkingStatus') }}</span>
                          </v-btn>

                          <!-- Cashout non available -->

                          <v-btn
                            v-if="
                              !betToShow.cashoutAvailable &&
                              !betToShow.isCheckingCashout
                            "
                            class="btn-cashout"
                            rounded
                            color="#a0c528"
                            dark
                          >
                            <span
                              v-if="betToShow.cashoutTemporarilyUnavailable"
                            >
                              {{ $t('cashout.notAvailable') }}
                            </span>
                            <span v-else>
                              {{ $t('cashout.notAvailable') }}
                            </span>
                          </v-btn>
                        </td>
                      </tr>
                      <tr>
                        <td class="mybet-col-sx">{{ $t('winning') }}</td>
                        <td class="mybet-col-dx">
                          <div
                            class="icon"
                            :style="
                              betToShow.result == 'pending'
                                ? 'display: flex'
                                : ''
                            "
                          >
                            {{
                              betToShow.winning_real
                                ? betToShow.currencySymbol +
                                  ' ' +
                                  parseFloat(betToShow.winning_real).toFixed(2)
                                : betToShow.currencySymbol + ' 0.00'
                            }}
                            <span
                              v-if="betToShow.result == 'pending'"
                              class="list-pending result-icon"
                              :title="$t(betToShow.result)"
                              style="display: flex"
                            >
                              <div
                                class="circle-pending"
                                style="margin: 5px 5px"
                              ></div>
                            </span>
                            <span
                              v-if="betToShow.result == 'lose'"
                              class="red--text result-icon"
                              :title="$t(betToShow.result)"
                            >
                              <v-icon small color="red"
                                >mdi-close-circle</v-icon
                              >
                            </span>
                            <span
                              v-if="betToShow.result == 'win'"
                              class="green--text result-icon"
                              :title="$t(betToShow.result)"
                            >
                              <v-icon small color="green"
                                >mdi-checkbox-marked-circle</v-icon
                              >
                              <small
                                class="light-green--text"
                                v-if="betToShow.cashout"
                                >(cashout)</small
                              >
                            </span>
                            <span
                              v-if="betToShow.result == 'void'"
                              class="blue--text result-icon"
                              :title="$t(betToShow.result)"
                            >
                              <v-icon small color="blue"
                                >mdi-alert-circle</v-icon
                              >
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-container
                  fluid
                  class="no-padding no-margin"
                  style="padding: 0 35px 0 10px !important; font-size: 12px"
                >
                  <v-row>
                    <v-col cols="12" md="3">
                      {{ $t('event') | capitalize }}</v-col
                    >
                    <v-col cols="12" md="2">
                      {{ $t('tournament') | capitalize }}</v-col
                    >
                    <v-col cols="12" md="1">{{
                      $t('sign') | capitalize
                    }}</v-col>
                    <v-col cols="12" md="1">
                      {{ $t('odd') | capitalize }}</v-col
                    >
                    <v-col cols="12" md="1">{{
                      $t('oddLive') | capitalize
                    }}</v-col>
                    <v-col cols="12" md="1">{{
                      $t('date') | capitalize
                    }}</v-col>
                    <v-col cols="12" md="1" class="text-center"
                      >{{ $t('score') | capitalize }}
                    </v-col>
                    <v-col cols="12" md="1" class="text-center">
                      {{ $t('result') | capitalize }}
                    </v-col>
                  </v-row>
                </v-container>
                <v-expansion-panels tile multiple class="tree">
                  <v-expansion-panel
                    v-for="(odd, index) in getDetailMyBets.odds"
                    :key="index"
                  >
                    <template>
                      <v-expansion-panel-header class="tree-sport-level">
                        <v-container
                          fluid
                          class="no-padding no-margin"
                          style="font-size: 12px"
                        >
                          <v-row>
                            <v-col cols="12" md="3"
                              >{{
                                odd.event_description != null
                                  ? odd.event_description
                                  : odd.tournament.name
                              }}
                            </v-col>
                            <v-col cols="12" md="2">
                              {{ odd.sport.name }}
                              <v-icon x-small>mdi-chevron-right</v-icon>
                              {{ odd.category.name }}
                              <v-icon x-small>mdi-chevron-right</v-icon>
                              {{ odd.tournament.name }}

                              <span v-if="getOddCurrentScore(odd)">
                                <span class="yellow--text">{{
                                  getOddCurrentScore(odd)
                                }}</span>
                              </span>
                              <v-icon v-if="getLivescoreMinute(odd)" x-small
                                >mdi-timer</v-icon
                              >
                              <span v-if="getLivescoreMinute(odd)">
                                {{ getLivescoreMinute(odd) }}'
                              </span>
                            </v-col>
                            <v-col cols="12" md="1">
                              <span>{{
                                odd.outcome_alias || odd.outcome_name
                              }}</span
                              ><span>
                                ( {{ odd.market_name }}
                                {{ getSpecifiers(odd.market_unique_id) }})
                              </span>
                            </v-col>
                            <v-col cols="12" md="1">
                              <span
                                >{{ odd.outcome_odd_value | odds_type_filter }}
                              </span>
                            </v-col>
                            <!--                            <v-col cols="12" md="1">-->
                            <!--                              <span>{{ odd.outcome_odd_value | odds_type_filter }} </span>-->
                            <!--                            </v-col>-->

                            <v-col cols="12" md="1">
                              <span v-if="isMatchInProgress(odd) && odd.liveOdd"
                                >{{ odd.liveOdd | odds_type_filter }}
                              </span>
                            </v-col>
                            <v-col cols="12" md="1">
                              {{
                                new Date(odd.time).toLocaleDateString('en-GB', {
                                  month: 'numeric',
                                  day: 'numeric',
                                })
                              }}
                              {{
                                new Date(odd.time).toLocaleTimeString([], {
                                  hour: '2-digit',
                                  minute: '2-digit',
                                })
                              }}
                              <!--{{ (odd.time > 0) ? new Date(odd.time).toLocaleString() : '' }}-->
                            </v-col>
                            <v-col cols="12" md="1" class="text-center">
                              <template v-if="odd.match_result">
                                [{{ odd.match_result }}]
                              </template>
                            </v-col>
                            <v-col cols="12" md="1" class="text-center">
                              <div
                                v-if="betToShow.cashout && !odd.result"
                                :title="$t('cashout')"
                              >
                                <v-icon small color="blue"
                                  >mdi-alert-circle</v-icon
                                >
                              </div>
                              <div
                                v-if="betToShow.cashout && odd.result"
                                :title="$t('win')"
                              >
                                <v-icon small color="green"
                                  >mdi-checkbox-marked-circle
                                </v-icon>
                              </div>
                              <div
                                v-if="
                                  !betToShow.cashout && odd.result == undefined
                                "
                                :title="$t('pending')"
                              >
                                <div
                                  class="circle-pending"
                                  style="margin: 4px auto"
                                ></div>
                              </div>
                              <div
                                v-else-if="!betToShow.cashout && odd.void"
                                :title="$t('void')"
                              >
                                <v-icon small color="blue"
                                  >mdi-alert-circle</v-icon
                                >
                              </div>
                              <div
                                v-else-if="!betToShow.cashout && odd.cancelled"
                                :title="$t('cancelled')"
                              >
                                <v-icon small color="yellow"
                                  >mdi-alert-circle</v-icon
                                >
                              </div>
                              <div
                                v-else-if="!betToShow.cashout && odd.result"
                                :title="$t('win')"
                              >
                                <v-icon small color="green"
                                  >mdi-checkbox-marked-circle
                                </v-icon>
                              </div>
                              <div
                                v-else-if="!betToShow.cashout && !odd.result"
                                :title="$t('lose')"
                              >
                                <v-icon small color="red"
                                  >mdi-close-circle</v-icon
                                >
                              </div>
                              <div
                                v-if="!betToShow.cashout && odd.half_won"
                                :title="$t('halfWon')"
                              >
                                <v-icon small color="green"
                                  >mdi-star-half</v-icon
                                >
                              </div>
                              <div
                                v-else-if="!betToShow.cashout && odd.half_lost"
                                :title="$t('halfLost')"
                              >
                                <v-icon small color="red">mdi-star-half</v-icon>
                              </div>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="no-padding">
                        <v-expansion-panels tile class="tree-inner">
                          <v-expansion-panel>
                            <!-- STATISTICHE LIVE -->
                            <div
                              v-if="
                                odd.livescore &&
                                odd.livescore.Statistics &&
                                odd.livescore.Statistics.length > 0
                              "
                              class="live-statistics"
                            >
                              <v-divider></v-divider>
                              <div class="statistics-title">
                                {{ $t('statistics.statistics') }}
                              </div>

                              <div
                                class="stat-grid"
                                v-for="(row, ridx) in statGridRows(odd)"
                              >
                                <!-- HEADER -->
                                <div class="stat-grid-row stat-grid-header">
                                  <div
                                    v-for="(cell, idx) in row"
                                    :key="'header-' + idx"
                                    class="stat-grid-cell stat-grid-header-cell"
                                  >
                                    {{
                                      cell && cell.Type
                                        ? getStatLabel(
                                            getStatTypeLabel(cell.Type, odd)
                                          )
                                        : ''
                                    }}
                                  </div>
                                </div>
                                <!-- RIGA DEI VALORI -->
                                <div class="stat-grid-row">
                                  <div
                                    v-for="(cell, cidx) in row"
                                    :key="
                                      cell && cell.Type
                                        ? cell.Type
                                        : 'empty-' + cidx
                                    "
                                    class="stat-grid-cell stat-grid-value-cell"
                                  >
                                    <span
                                      v-if="
                                        cell &&
                                        cell.Results &&
                                        Array.isArray(cell.Results)
                                      "
                                    >
                                      {{ getStatHomeAwayDisplay(cell) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- INCIDENTI PER PERIODO -->

                            <!-- INCIDENTI LIVE PERIODI - GRIGLIA MULTI-COLONNA -->
                            <div
                              v-if="
                                odd.livescore &&
                                odd.livescore.Periods &&
                                odd.livescore.Periods.length > 0
                              "
                            >
                              <div class="incid-title">
                                {{ $t('statistics.incidents') }}
                              </div>
                              <div
                                v-for="(period, pidx) in odd.livescore.Periods"
                                :key="'period-' + pidx"
                                class="period-incidents"
                              >
                                <div class="period-label">
                                  {{
                                    period.Type && period.Type[0]
                                      ? period.Type[0].text
                                      : 'Set/Game'
                                  }}
                                </div>
                                <div
                                  v-if="
                                    period.Incidents &&
                                    period.Incidents.length > 0
                                  "
                                  class="inc-grid"
                                >
                                  <!-- HEADER INCIDENTI -->
                                  <div class="inc-grid-row inc-grid-header">
                                    <div
                                      v-for="(cell, idx) in getIncHeaders(
                                        period
                                      )"
                                      :key="'inc-header-' + idx"
                                      class="inc-grid-cell inc-grid-header-cell"
                                    >
                                      {{ cell.label }}
                                    </div>
                                  </div>
                                  <!-- RIGHE INCIDENTI -->
                                  <div
                                    v-for="row in getIncRows(period)"
                                    class="inc-grid-row"
                                  >
                                    <div
                                      v-for="(cell, cidx) in row"
                                      :key="
                                        cell && cell.key
                                          ? cell.key
                                          : 'empty-' + cidx
                                      "
                                      class="inc-grid-cell inc-grid-value-cell"
                                    >
                                      <span v-if="cell">
                                        <span class="inc-label">{{
                                          cell.label
                                        }}</span>
                                        <span
                                          class="inc-val"
                                          :title="cell.label"
                                          >{{ cell.value }}</span
                                        >
                                        <small
                                          v-if="cell.seconds"
                                          class="inc-sec"
                                          >{{ cell.seconds }}</small
                                        >
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- FALLBACK "NO INFO" compatibile Node 14 (NO optional chaining)-->
                            <div
                              v-if="
                                !(
                                  odd.livescore &&
                                  odd.livescore.Statistics &&
                                  odd.livescore.Statistics.length > 0
                                ) &&
                                !(
                                  odd.livescore &&
                                  odd.livescore.Periods &&
                                  odd.livescore.Periods.length > 0 &&
                                  odd.livescore.Periods.some(function (p) {
                                    return p.Incidents && p.Incidents.length > 0
                                  })
                                )
                              "
                              class="text-center"
                              style="margin-top: 12px"
                            >
                              <!--                              {{$t('noinfo')}}-->

                              <span id="diomaledetto" style="display: none"
                                >${{ odd }}</span
                              >
                            </div>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-expansion-panel-content>
                    </template>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" text @click="dialog = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div
      v-if="showCashoutModal"
      class="custom-modal-overlay"
      @click.self="closeModal"
    >
      <div class="custom-modal-container">
        <div class="custom-modal">
          <div class="modal-header">
            <h3 style="text-transform: capitalize">{{ modalTitle }}</h3>
          </div>
          <div class="modal-body">
            <p v-html="modalMessage"></p>
          </div>
          <div class="modal-footer">
            <button
              v-if="showCancelButton"
              class="modal-cancel-btn"
              @click="cancelModalAction"
            >
              {{ cancelButtonText }}
            </button>
            <button
              v-if="showConfirmButton"
              class="modal-confirm-btn"
              @click="confirmModalAction"
            >
              {{ confirmButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import orderByLodash from 'lodash/orderBy'
import { isMobileOnly } from 'mobile-device-detect'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../../plugins/device-inspector'

const STATISTICS_LABELS = {
  // FOOTBALL/SOCCER
  8412615417: {
    1: 'Corners',
    2: 'Shots On Target',
    3: 'Shots Off Target',
    4: 'Attacks',
    5: 'Dangerous Attacks',
    6: 'Yellow Card',
    7: 'Red Card',
    8: 'Penalties',
    9: 'Goal',
    10: 'Substitutions',
    11: 'Possession',
    12: 'Fouls',
    13: 'Free Kicks',
    14: 'Goal Kicks',
    15: 'Offsides',
    16: 'Blocked Shots',
    17: 'Throw Ins',
    18: 'Woodwork Shots',
    24: 'Own Goal',
    27: 'Score',
    96: 'Goalkeeper Saves',
    102: 'Player Minutes Played',
    148: 'Pass Attempts',
    149: 'Pass Completions',
    1028: 'Player Blocked Shots',
    1036: 'Player Assists',
    2001: 'Player Goals',
    2003: 'Player Tackles',
    2004: 'Player Saves',
    2005: 'Player Shots On Target',
    2006: 'Player Shots Off Target',
    2007: 'Player Fouls',
    2034: 'Assists',
    2154: 'Player Offsides',
    2155: 'Player Yellow Card',
    2173: 'Player Red Card',
    2228: 'Tackles',
    2255: 'Player Total Shots',
    2289: 'Header Goals',
    2344: 'Woodwork Shots',
  },
  // TENNIS
  3467550448: {
    20: 'Aces',
    21: 'Double Faults',
    22: 'Service Points',
    23: 'Break Points',
    27: 'Score',
    34: 'First Serve Wins',
    55: 'Number Of Points',
    63: 'Second Serve Return Points Won',
    65: 'Service Game Won',
    67: 'Break Points Saved',
    68: 'Second Serve Wins',
    70: 'First Serve Return Points Won',
    78: 'Return Games Played',
    2044: 'Service Points Won',
    2045: 'Receiver Points Won',
    2065: 'Max Points In Row',
    2066: 'First Serve Percentage',
    2068: 'Service Errors',
    2090: 'Max Games In Row',
    2094: 'Second Serve Percentage',
    2095: 'Break Points Won Percentage',
    2147: 'Total Games Won',
    2194: 'Successful 1st Serves (Raw)',
    2195: '1st Serve Points Won (%)',
    2196: '2nd Serve Points Won (%)',
    2197: 'Successful 2nd Serves (Raw)',
    2198: '1st Serve Return Points Won (%)',
    2199: '2nd Serve Return Points Won (%)',
    2202: 'Tie Breaks Won (Raw)',
    2205: '1st Serve Attempts (Raw)',
    2206: '2nd Serve Attempts (Raw)',
    2207: '1st Serve Points Played (Raw)',
    2208: '2nd Serve Points Played (Raw)',
    2209: 'Break Points Attempts (Raw)',
    2231: '1st Serve Return Points Played',
    2232: '2nd Serve Return Points Played',
    2299: 'Service Games Played (Raw)',
  },
  // BASKETBALL
  5177137473: {
    12: 'Fouls',
    27: 'Score',
    28: '2 Points',
    30: '3 Points',
    31: 'Timeouts',
    32: 'Free Throws',
    98: 'Player Technical Fouls',
    99: 'Player Blocks Against',
    100: 'Player Defensive Rebounds',
    101: 'Player Offensive Rebounds',
    102: 'Player Minutes Played',
    103: 'Player Field Goals Made',
    104: 'Player Total Rebounds',
    105: 'Player Personal Fouls',
    106: 'Player Free Throws Made',
    107: 'Player Field Goals Attempted',
    108: 'Player 2-Point FG Made',
    109: 'Player Steals',
    110: 'Player Free Throws Attempted',
    111: 'Player 3-Point FG Attempted',
    112: 'Player Turnovers',
    113: 'Player 3-Point FG Made',
    114: 'Player 2-Point FG Attempted',
    1025: 'Player +/- Points',
    1028: 'Player Blocked Shots',
    1033: 'Player Points',
    1036: 'Player Assists',
    2007: 'Player Fouls',
    2029: 'Rebounds',
    2030: 'Defensive Rebounds',
    2031: 'Offensive Rebounds',
    2034: 'Assists',
    2035: 'Steals',
    2214: 'Player Free Throws Made (%)',
    2222: 'Player 2 Pointers Made (%)',
    2223: 'Player 3 Pointers Made (%)',
    2224: 'Player FG Made (%)',
  },
  // VOLLEYBALL (esempio)
  2908586663: {
    16: 'Blocked Shots',
    20: 'Aces',
    27: 'Score',
  },
  // BASEBALL (esempio)
  4105083646: {
    27: 'Score',
    33: 'Hits',
    93: 'Runs',
    1009: 'Pitcher Base on Balls',
    1010: 'Pitcher Strikeouts',
    1022: 'Batter Strikeouts',
    1023: 'Batter Left on Base',
    2080: 'Doubles',
    2081: 'Triples',
    2082: 'Home Runs',
    2083: 'Strike Outs',
    2096: 'Errors',
    2097: 'Stolen Bases',
    // ...ecc...
  },
  // ...aggiungi altri sportId qui sotto!
}

export default {
  name: 'MyBetsCashoutV2',
  data() {
    return {
      dialog: false,
      dialog_cashout: false,
      dialog_cashout_accept: false,
      dialog_cashout_reject: false,
      dialog_betlist: false,
      overlay_dialog_betlist: false,
      overlay_dialog_betlist_detail: false,
      betToShow: {},
      betToShowAll: {},
      loading: false,
      rules_manager: [],
      rules_skin: [],
      cashout: 0,
      overlay: false,
      isMobileOnly: isMobileOnly,
      cashout_value: 0,
      cashout_prematch: 0,
      potential_win: 0,

      skeleton_loader: false,
      showCashoutModal: false,
      modalTitle: '',
      modalMessage: '',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      currentBet: null,
      modalResolve: null,
      modalReject: null,
      modalPromise: null,
      modalStyle: {},
      scrollPosition: 0,
      cashoutIntervalId: null,
      currentPage: 1,
      numPerPage: 6,
      apiLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getMyBetsInProgress: 'user/getMyBetsInProgress',
      getPlatformSettings: 'settings/getPlatformSettings',
      getDetailMyBets: 'user/getDetailMyBets',
      getModalIdle: 'user/getModalIdle',
      getOddsType: 'odds/getOddsType',
      getSettings: 'cart/getSettings',
      getCashoutApiPollIntervalSec: 'settings/getCashoutApiPollIntervalSec',
      getMyBetsCashout: 'user/getMyBetsInProgressCashout',
      getCashoutPagination: 'user/getMyBetsPaginationCashout',
    }),
  },
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false
        }, 3000)
    },
  },
  methods: {
    ...mapActions({
      resetCart: 'cart/resetCart',
      setOddsInCart: 'cart/setOddsInCart',
      refreshCart: 'cart/refreshCart',
      fetchEventResultAndTimeDetail: 'odds/fetchEventResultAndTimeDetail',
      setCreatedAtCart: 'cart/setCreatedAtCart',
      setDetailMyBet: 'user/setDetailMyBet',
      calculateCashout: 'cart/calculateCashout',
      defineCashout: 'cart/defineCashout',
      fetchMyBetsInProgressCashoutPaginated:
        'user/fetchMyBetsInProgressCashoutPaginated',
    }),

    getOddCurrentScore(odd) {
      // 1. Se hai odd.result_actual && Array.isArray(odd.result_actual)
      if (odd.result_actual && Array.isArray(odd.result_actual)) {
        const home = odd.result_actual.find(r => r.Position == '1')
        const away = odd.result_actual.find(r => r.Position == '2')
        // Ritorna solo se almeno uno dei due c'è
        if (home || away) {
          return (home ? home.Value : '-') + ' - ' + (away ? away.Value : '-')
        }
      }
      // 2. Se hai livescore.Scoreboard.Results
      if (
        odd.livescore &&
        odd.livescore.Scoreboard &&
        Array.isArray(odd.livescore.Scoreboard.Results)
      ) {
        const home = odd.livescore.Scoreboard.Results.find(
          r => r.Position == '1'
        )
        const away = odd.livescore.Scoreboard.Results.find(
          r => r.Position == '2'
        )
        if (home || away) {
          return (home ? home.Value : '-') + ' - ' + (away ? away.Value : '-')
        }
      }
      // 3. Fallback (vuoto)
      return ''
    },

    getLivescoreCurrentResult(odd) {
      if (
        odd.livescore &&
        odd.livescore.Scoreboard &&
        Array.isArray(odd.livescore.Scoreboard.Results)
      ) {
        const home = odd.livescore.Scoreboard.Results.find(
          r => r.Position == '1'
        )
        const away = odd.livescore.Scoreboard.Results.find(
          r => r.Position == '2'
        )
        return (home ? home.Value : '-') + ' - ' + (away ? away.Value : '-')
      }
      return '' // fallback se mancano i dati
    },
    getLivescoreMinute(odd) {
      // 1. livescore.Scoreboard.Time (in secondi)
      if (
        odd.livescore &&
        odd.livescore.Scoreboard &&
        typeof odd.livescore.Scoreboard.Time !== 'undefined'
      ) {
        const timeSec = parseInt(odd.livescore.Scoreboard.Time, 10)
        if (!isNaN(timeSec) && timeSec >= 0) {
          return Math.floor(timeSec / 60)
        }
        // Se -1 o altro, NON mostro nulla!
        return ''
      }
      // 2. fallback su odd.time_actual (già in minuti)
      if (
        typeof odd.time_actual !== 'undefined' &&
        odd.time_actual !== null &&
        !isNaN(Number(odd.time_actual))
      ) {
        const minute = Math.floor(Number(odd.time_actual))
        if (minute >= 0) {
          return minute
        }
        // Se negative (es: -1), scarto!
        return ''
      }
      return ''
    },
    async goToPage(page) {
      if (page === this.currentPage) return
      this.currentPage = page
      this.loading = true
      await this.fetchMyBetsInProgressCashoutPaginated({
        all: false,
        betTypes: ['single', 'multiple'],
        page: this.currentPage,
        numPerPage: this.numPerPage,
      })
      await this.checkCashoutForPendingBets()
      this.loading = false
    },

    getStatLabel(label) {
      // Esempio: label = "Corners"
      // Prova a tradurre "statistics.Corners". Se non trova, fallback su label.
      const key = `statistics.${label}`
      const translation = this.$t(key)
      // fallback se NON c'è la traduzione (i $t Vue-i18n restituisce la chiave se manca)
      return translation !== key ? translation : label
    },

    isMatchInProgress(odd) {
      if (odd && (odd.status_event == 2 || odd.status_event === '2')) {
        return true
      }
      // fallback se vuoi compat App/vecchie versioni con status evento globale
      const status =
        this.betToShow &&
        this.betToShow.sport_event_status &&
        this.betToShow.sport_event_status._attributes &&
        this.betToShow.sport_event_status._attributes.status
      return status == 2 || status === '2'
    },
    getCurrentResultForOdd(odd) {
      return odd.result_live || ''
    },
    getMatchMinuteForOdd(odd) {
      return odd.time_live || ''
    },
    isMatchFinished(scoreboard) {
      // Restituisce true se la partita è finita o annullata, puoi aggiungere altri status se vuoi
      return scoreboard && String(scoreboard.Status) === '3'
    },
    getCurrentResult(scoreboard) {
      if (!scoreboard || !Array.isArray(scoreboard.Results)) return ''
      const home = scoreboard.Results.find(r => r.Position == '1')
      const away = scoreboard.Results.find(r => r.Position == '2')
      return (home ? home.Value : '-') + ' - ' + (away ? away.Value : '-')
    },

    getMatchMinute(scoreboard) {
      if (!scoreboard || typeof scoreboard.Time === 'undefined') return ''
      const t = parseInt(scoreboard.Time, 10)
      if (isNaN(t)) return ''
      const minutes = Math.floor(t / 60)
      // Se vuoi anche i secondi:
      // const seconds = t % 60;
      return minutes
    },

    getStatHomeAwayDisplay(stat) {
      if (!stat || !stat.Results || !Array.isArray(stat.Results)) return ''
      const home = stat.Results.find(r => r.Position == '1')
      const away = stat.Results.find(r => r.Position == '2')
      return (home ? home.Value : '-') + ' - ' + (away ? away.Value : '-')
    },

    getIncHeaders(period) {
      const maxCols = 6
      // Prendi al massimo 6 tipi diversi per header (puoi fare logica custom se vuoi)
      const typesSeen = {}
      const cells = []
      if (!(period && period.Incidents && period.Incidents.length)) return []
      for (
        let i = 0;
        i < period.Incidents.length && cells.length < maxCols;
        i++
      ) {
        const type = period.Incidents[i].IncidentType
        if (!typesSeen[type]) {
          typesSeen[type] = true
          cells.push({
            type,
            label: this.getIncidentTypeLabel(
              type,
              this.betToShow.odds && this.betToShow.odds[0]
                ? this.betToShow.odds[0]
                : this.betToShow
            ),
          })
        }
      }
      // Puoi forzare a sei colonne "fisse" se vuoi sempre 6 celle
      while (cells.length < maxCols) cells.push({ label: '', type: '' })
      return cells
    },

    getIncRows(period) {
      const maxCols = 6
      if (!(period && period.Incidents && period.Incidents.length)) return []
      const rows = []
      let row = []
      for (let i = 0; i < period.Incidents.length; i++) {
        const inc = period.Incidents[i]
        row.push({
          key: 'inc-' + i + '-' + inc.IncidentType,
          label: this.getIncidentTypeLabel(
            inc.IncidentType,
            this.betToShow.odds && this.betToShow.odds[0]
              ? this.betToShow.odds[0]
              : this.betToShow
          ),
          value: inc.Results && inc.Results[0] ? inc.Results[0].Value : '',
          seconds: inc.Seconds > 0 ? inc.Seconds + 's' : '',
        })
        if (row.length === maxCols) {
          rows.push(row)
          row = []
        }
      }
      // Completa a maxCols con oggetti VUOTI, NO null
      while (row.length > 0 && row.length < maxCols) {
        row.push({
          key: 'empty-' + row.length,
          label: '',
          value: '',
          seconds: '',
        })
      }
      if (row.length > 0) rows.push(row)
      return rows
    },
    statGridHeaders(odd, row) {
      // Per la riga, restituisci i label esattamente della riga visualizzata!
      return row.map(cell => ({
        type: cell.type || '',
        label: cell.type ? this.getStatTypeLabel(cell.type, odd) : '',
      }))
    },
    statGridRows(odd) {
      const stats =
        odd.livescore && odd.livescore.Statistics
          ? odd.livescore.Statistics
          : []
      const maxCols = 6
      const cells = []
      let row = []
      for (let i = 0; i < stats.length; i++) {
        row.push(stats[i]) // Qui passa l'intero oggetto
        if (row.length === maxCols) {
          cells.push(row)
          row = []
        }
      }
      if (row.length > 0) {
        while (row.length < maxCols) row.push({}) // oggetti vuoti
        cells.push(row)
      }
      return cells
    },

    getStatTypeLabel(type, odd) {
      const sportId =
        (odd && odd.sport && odd.sport.id) ||
        (odd && odd.sport_id) ||
        (this.betToShow && this.betToShow.sport_id)
      const mappa = STATISTICS_LABELS[sportId]
      if (!mappa) return 'Stat ' + type
      return mappa[type] || 'Stat ' + type
    },
    getIncidentTypeLabel(type, odd) {
      const sportId =
        (odd && odd.sport && odd.sport.id) ||
        (odd && odd.sport_id) ||
        (this.betToShow && this.betToShow.sport_id)
      const map = STATISTICS_LABELS[sportId]
      if (!map) return 'Inc. ' + type
      return map[type] || 'Inc. ' + type
    },

    showModal(options) {
      this.dialog = false
      if (options.closeBetDetail === true) {
        this.dialog = false //  disable the modal detail bet
      }

      // Blocca lo scroll
      this.scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.top = `-${this.scrollPosition}px`
      document.body.style.width = '100%'

      this.modalTitle = options.title || ''
      this.modalMessage = options.html || options.text || ''
      this.showConfirmButton = options.showConfirmButton !== false
      this.showCancelButton = options.showCancelButton !== false
      this.confirmButtonText =
        this.$t('cashout.confirmButton') || options.confirmButtonText
      this.cancelButtonText =
        this.$t('cashout.cancelButton') || options.cancelButtonText
      this.showCashoutModal = true

      // Aggiunta gestione autoClose
      if (options.autoClose) {
        setTimeout(() => {
          this.closeModal()
        }, options.autoClose)
      }

      return new Promise(resolve => {
        this.modalPromise = resolve

        // Se non ci sono bottoni (e quindi promise potenzialmente bloccata), chiudi dopo autoClose
        if (
          !this.showConfirmButton &&
          !this.showCancelButton &&
          options.autoClose
        ) {
          console.log(
            'If there are no buttons (and thus potentially blocked promise), close after autoClose'
          )
          setTimeout(() => {
            // Risolvi la promise (chiudi con stato personalizzato, ad es. 'autoclosed')
            if (this.modalPromise) {
              this.modalPromise({ isConfirmed: true, autoclosed: true })
              this.modalPromise = null
            }
          }, options.autoClose)
        }
      })
    },

    // Centra la modale nella viewport visibile
    centerModal() {
      if (!this.$refs.modal) return

      const modalHeight = this.$refs.modal.offsetHeight
      const windowHeight = window.innerHeight
      const offset = Math.max(0, (windowHeight - modalHeight) / 3) // 1/3 dall'alto

      this.modalStyle = {
        top: `${offset}px`,
        opacity: '1',
        transform: 'translate(-50%, 0)',
      }
    },

    // Chiude la modale e ripristina lo scroll
    closeModal(options) {
      this.showCashoutModal = false

      if (options.openBetDetailModal === true) {
        this.dialog = true
      }
      // Ripristina lo scroll della pagina
      document.body.style.removeProperty('overflow')
      document.body.style.removeProperty('position')
      document.body.style.removeProperty('top')
      document.body.style.removeProperty('width')
      window.scrollTo(0, this.scrollPosition)

      if (this.modalPromise) {
        this.modalPromise({ isConfirmed: false, dismiss: 'overlay' })
        this.modalPromise = null
      }
    },

    // Azioni della modale
    confirmModalAction() {
      if (this.modalPromise) {
        this.modalPromise({ isConfirmed: true })
        this.modalPromise = null
      }
      this.closeModal()
    },

    cancelModalAction() {
      if (this.modalPromise) {
        this.modalPromise({ isConfirmed: false, dismiss: 'cancel' })
        this.modalPromise = null
      }
      this.closeModal({ openBetDetailModal: true })
    },

    // Funzione processCashout ottimizzata
    async processCashout(bet) {
      // 1. Prima conferma
      this.$set(bet, 'isProcessingCashout', true)
      const confirm1 = await this.showModal({
        title: this.$t('cashout.confirmTitle'),
        text: this.$t('cashout.confirmText'),
        confirmButtonText: this.$t('cashout.yesContinue'),
        cancelButtonText: this.$t('cashout.cancelButton'),
        showCancelButton: true,
        showConfirmButton: true,
        closeBetDetail: true,
      })
      if (!confirm1.isConfirmed) {
        this.$set(bet, 'isProcessingCashout', false)
        return
      }
      await this.$nextTick()

      // 2. Recupera cashout aggiornato dal server
      let updatedCashoutValue = bet.cashoutValue
      let updatedCashoutError = null
      try {
        const response = await this.calculateCashout({
          code: bet.code,
          useMinuteEvaluation: true,
        })

        if (
          response &&
          response.data &&
          response.data.result === true &&
          response.data.cashoutData
        ) {
          updatedCashoutValue = response.data.cashoutData.cashoutToConsider3
          this.$set(bet, 'cashoutValue', updatedCashoutValue)
          this.$set(bet, 'cashoutAvailable', true)
          this.$set(bet, 'cashoutError', null)
          this.$set(bet, 'cashoutTemporarilyUnavailable', false)
        } else {
          // PATCH: distingue tra cashout disabilitato definitivo e temporaneo
          const errors =
            response.data && response.data.errors ? response.data.errors : []
          const isDisabled =
            Array.isArray(errors) &&
            errors.some(
              e => (e.code || '').toUpperCase() === 'CASHOUT_DISABLED'
            )
          if (isDisabled) {
            // Disabilitato definitivamente
            updatedCashoutError = this.$t('cashout.notAvailable')
            this.$set(bet, 'cashoutAvailable', false)
            this.$set(bet, 'cashoutTemporarilyUnavailable', false)
            this.$set(bet, 'cashoutError', errors)
            this.$set(bet, 'cashoutValue', null)
          } else {
            // Solo momentaneamente non disponibile
            updatedCashoutError = this.$t('cashout.temporarilyUnavailable')
            this.$set(bet, 'cashoutAvailable', false)
            this.$set(bet, 'cashoutTemporarilyUnavailable', true)
            this.$set(
              bet,
              'cashoutError',
              errors.length > 0 ? errors : updatedCashoutError
            )
            this.$set(bet, 'cashoutValue', null)
          }
        }
      } catch (err) {
        updatedCashoutError = err.message || this.$t('cashout.errorText')
        this.$set(bet, 'cashoutAvailable', false)
        this.$set(bet, 'cashoutTemporarilyUnavailable', false) // meglio: errore grave non momentaneo
        this.$set(bet, 'cashoutError', updatedCashoutError)
        this.$set(bet, 'cashoutValue', null)
      }
      await this.$nextTick()

      // 3. Se cashout non disponibile, mostra modale errore e interrompi
      if (!bet.cashoutAvailable || !updatedCashoutValue) {
        await this.showModal({
          title: this.$t('cashout.temporarilyUnavailableTitle'),
          text:
            updatedCashoutError || this.$t('cashout.temporarilyUnavailable'),
          confirmButtonText: this.$t('generic.close'),
          showCancelButton: false,
          showConfirmButton: true,
        })
        this.$set(bet, 'isCheckingCashout', false)
        this.$set(bet, 'isProcessingCashout', false)
        return
      }

      // 4. Seconda conferma con cashout aggiornato
      const formattedAmount =
        this.getSettings.currencySymbol + this.formatNumber(updatedCashoutValue)
      const confirm2 = await this.showModal({
        title: this.$t('cashout.finalConfirmTitle'),
        text: this.$t('cashout.finalConfirmText', {
          amount: '<strong>' + formattedAmount + '</strong>',
        }),
        confirmButtonText: this.$t('cashout.confirmButton'),
        cancelButtonText: this.$t('cashout.cancelButton'),
        showCancelButton: true,
        showConfirmButton: true,
      })
      if (!confirm2.isConfirmed) {
        this.$set(bet, 'isProcessingCashout', false)
        return
      }
      await this.$nextTick()

      // 5. Chiamata reale all'API cashout
      try {
        const response = await this.defineCashout({ code: bet.code })
        const apiResult = response && response.data ? response.data : null
        if (
          apiResult &&
          apiResult.result === true &&
          apiResult.cashoutConfirmed === true
        ) {
          // Successo cashout
          await this.showModal({
            title: this.$t('cashout.successTitle'),
            text: this.$t('cashout.successText', {
              amount: '<strong>' + formattedAmount + '</strong>',
            }),
            showCancelButton: false,
            showConfirmButton: false,
            autoClose: 2000,
          })
          this.$set(bet, 'cashoutAvailable', false)
          this.$set(bet, 'cashoutProcessed', true)
          this.$set(bet, 'isCheckingCashout', false)
          this.$set(bet, 'isProcessingCashout', false)
          this.dialog = false
          await this.initialize()
        } else {
          let errorMsg = this.$t('cashout.errorText')
          let errors = []
          let isDisabled = false
          if (
            apiResult &&
            apiResult.paymentResult &&
            apiResult.paymentResult.errors
          ) {
            errors = apiResult.paymentResult.errors
          } else if (
            apiResult &&
            apiResult.errors &&
            apiResult.errors.length > 0
          ) {
            errors = apiResult.errors
          }

          // PATCH: gestione FROZEN_EXPIRED
          const isFrozenExpired =
            Array.isArray(errors) &&
            errors.some(e => (e.code || '').toUpperCase() === 'FROZEN_EXPIRED')
          if (isFrozenExpired) {
            await this.showModal({
              title: this.$t('error'),
              html: `
                  <div style="display: flex; align-items: center; flex-direction:column;">
                    <span class="mdi mdi-timer-sand my-frozen-loader" style="color: #e53935; font-size:36px;"></span>
                    <span style="color:#ff9800; font-weight:bold; margin-top:1rem; font-size:1.1em;">
                      ${
                        this.$t('cashout.frozenExpired') ||
                        'In the meantime, the odds changed! Please try again quickly.'
                      }
                    </span>
                    <span style="color:#d32f2f; font-size:0.98em; margin-top:0.5em;">
                      ${
                        this.$t('cashout.frozenExpiredHint') ||
                        'Cashout must be confirmed quickly to guarantee the current offer.'
                      }
                    </span>
                  </div>
                    `,
              confirmButtonText: this.$t('generic.close'),
              showCancelButton: false,
              showConfirmButton: true,
            })
            this.$set(bet, 'cashoutAvailable', false)
            this.$set(bet, 'cashoutTemporarilyUnavailable', false)
            this.$set(bet, 'cashoutError', errors)
            this.$set(bet, 'cashoutValue', null)
            this.$set(bet, 'isCheckingCashout', false)
            this.$set(bet, 'isProcessingCashout', false)
            return
          }

          isDisabled =
            Array.isArray(errors) &&
            errors.some(
              e => (e.code || '').toUpperCase() === 'CASHOUT_DISABLED'
            )
          if (isDisabled) {
            this.$set(bet, 'cashoutAvailable', false)
            this.$set(bet, 'cashoutTemporarilyUnavailable', false)
            this.$set(bet, 'cashoutError', errors)
            this.$set(bet, 'cashoutValue', null)
            errorMsg = this.$t('cashout.notAvailable')
          } else {
            this.$set(bet, 'cashoutAvailable', false)
            this.$set(bet, 'cashoutTemporarilyUnavailable', true)
            this.$set(
              bet,
              'cashoutError',
              errors.length > 0 ? errors : errorMsg
            )
            this.$set(bet, 'cashoutValue', null)
          }
          await this.showModal({
            title: this.$t('cashout.failedTitle') || this.$t('error'),
            text: errorMsg,
            confirmButtonText: this.$t('generic.close'),
            showCancelButton: false,
            showConfirmButton: true,
          })
          this.$set(bet, 'isCheckingCashout', false)
          this.$set(bet, 'isProcessingCashout', false)
        }
      } catch (error) {
        await this.showModal({
          title: this.$t('error'),
          text: this.$t('cashout.errorText'),
          confirmButtonText: this.$t('generic.close'),
          showCancelButton: false,
          showConfirmButton: true,
        })
        this.$set(bet, 'cashoutAvailable', false)
        this.$set(bet, 'cashoutTemporarilyUnavailable', false) // meglio: errore grave
        this.$set(bet, 'isCheckingCashout', false)
        this.$set(bet, 'isProcessingCashout', false)
      } finally {
        this.$set(bet, 'isProcessingCashout', false)
      }
    },
    formatNumber(value) {
      return parseFloat(value || 0).toFixed(2)
    },

    async checkCashoutForPendingBets() {
      const pendingBets = this.getMyBetsCashout.filter(
        bet =>
          bet.result === 'pending' &&
          bet.cashoutValue == null &&
          !bet.isCheckingCashout &&
          !bet.hasOddOutOfRange &&
          !bet.hasEventsOutOfRange
      )

      if (pendingBets.length === 0) return

      const cashoutPromises = pendingBets.map(async bet => {
        const betIndex = this.getMyBetsCashout.findIndex(
          b => b.code === bet.code
        )
        if (betIndex === -1) return
        this.$set(this.getMyBetsCashout[betIndex], 'isCheckingCashout', true)

        try {
          const response = await this.calculateCashout({
            code: bet.code,
            useMinuteEvaluation: true,
          })
          const errors =
            response.data && response.data.errors ? response.data.errors : []

          // PATCH #1: Se c'è almeno un ODD_OUT_OF_RANGE, blocca polling futuro per questa bet
          const hasOddOutOfRange = errors.some(
            e => (e.code || '').toUpperCase() === 'ODD_OUT_OF_RANGE'
          )
          this.$set(
            this.getMyBetsCashout[betIndex],
            'hasOddOutOfRange',
            hasOddOutOfRange
          )

          // PATCH #2: Se c'è almeno uno tra MIN/MAX_EVENTS_NOT_REACHED, blocca polling futuro per questa bet
          const hasEventsOutOfRange = errors.some(e => {
            const code = (e.code || '').toUpperCase()
            return (
              code === 'MIN_EVENTS_NOT_REACHED' ||
              code === 'MAX_EVENTS_NOT_REACHED'
            )
          })
          this.$set(
            this.getMyBetsCashout[betIndex],
            'hasEventsOutOfRange',
            hasEventsOutOfRange
          )

          // Se almeno una delle due condizioni è vera: NON fare altri polling cashout su questa bet!
          if (hasOddOutOfRange || hasEventsOutOfRange) {
            this.$set(
              this.getMyBetsCashout[betIndex],
              'cashoutAvailable',
              false
            )
            this.$set(
              this.getMyBetsCashout[betIndex],
              'cashoutTemporarilyUnavailable',
              false
            )
            this.$set(this.getMyBetsCashout[betIndex], 'cashoutError', errors)
            this.$set(this.getMyBetsCashout[betIndex], 'cashoutValue', null)
            return
          }

          // Se cashout disponibile normalmente
          if (
            response.data &&
            response.data.result === true &&
            response.data.cashoutData
          ) {
            this.$set(
              this.getMyBetsCashout[betIndex],
              'cashoutValue',
              response.data.cashoutData.cashoutToConsider3
            )
            this.$set(this.getMyBetsCashout[betIndex], 'cashoutAvailable', true)
            this.$set(
              this.getMyBetsCashout[betIndex],
              'cashoutTemporarilyUnavailable',
              false
            )
            this.$set(this.getMyBetsCashout[betIndex], 'cashoutError', null)
          } else {
            // Altre condizioni di errore
            const isDisabled =
              Array.isArray(errors) &&
              errors.some(
                e => (e.code || '').toUpperCase() === 'CASHOUT_DISABLED'
              )
            if (isDisabled) {
              this.$set(
                this.getMyBetsCashout[betIndex],
                'cashoutAvailable',
                false
              )
              this.$set(
                this.getMyBetsCashout[betIndex],
                'cashoutTemporarilyUnavailable',
                false
              )
              this.$set(this.getMyBetsCashout[betIndex], 'cashoutValue', null)
              this.$set(this.getMyBetsCashout[betIndex], 'cashoutError', errors)
            } else {
              this.$set(
                this.getMyBetsCashout[betIndex],
                'cashoutAvailable',
                false
              )
              this.$set(
                this.getMyBetsCashout[betIndex],
                'cashoutTemporarilyUnavailable',
                true
              )
              this.$set(this.getMyBetsCashout[betIndex], 'cashoutValue', null)
              this.$set(
                this.getMyBetsCashout[betIndex],
                'cashoutError',
                errors.length > 0 ? errors : 'Cashout not available'
              )
            }
          }

          // Aggiorna anche betToShow se è quella attualmente visualizzata nei dettagli
          if (this.betToShow && this.betToShow.code === bet.code) {
            this.betToShow = this.getMyBetsCashout[betIndex]
          }
        } catch (error) {
          this.$set(this.getMyBetsCashout[betIndex], 'cashoutAvailable', false)
          this.$set(
            this.getMyBetsCashout[betIndex],
            'cashoutTemporarilyUnavailable',
            false
          )
          this.$set(
            this.getMyBetsCashout[betIndex],
            'cashoutError',
            error.message || 'Cashout not available'
          )
          this.$set(this.getMyBetsCashout[betIndex], 'cashoutValue', null)
        } finally {
          this.$set(this.getMyBetsCashout[betIndex], 'isCheckingCashout', false)
        }
      })

      await Promise.allSettled(cashoutPromises)
    },

    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },

    getDialogCashout(cashout_value, potential_win, simbol) {
      this.dialog_cashout = true
      this.cashout_value = simbol + ' ' + cashout_value
      this.potential_win = simbol + ' ' + potential_win
    },

    printBet(code) {
      window.open(
        this.getPlatformSettings.print_endpoint +
          code +
          '&type_odd=' +
          this.getOddsType,
        '_blank',
        'height=600,width=350'
      )
    },

    async openDetail(bet) {
      this.overlay_dialog_betlist = true
      this.overlay = true
      // Focus UI fix
      const sleep = m => new Promise(r => setTimeout(r, m))
      await sleep(100)
      if (typeof document !== 'undefined') {
        document.body.scrollIntoView({ behavior: 'smooth', block: 'start' })
        window.parent.postMessage({ type: 'scrollTop' }, '*')
      }
      this.betToShow = bet
      const odds = this.betToShow.odds || []

      try {
        // 1. CASHOUT PROMISE
        const cashoutPromise = this.calculateCashout({
          code: this.betToShow.code,
          useMinuteEvaluation: true,
        }).catch(error => error)

        // 2. LIVECORE PER OGNI ODD
        const liveOddsPromises = odds.map(async odd => {
          // if (!odd.livescore) {
          try {
            const data = await this.getLiveDate(odd.event_source, odd.ext_id)
            if (data && data.livescore) {
              this.$set(odd, 'livescore', data.livescore)
            }

            if (data && data.outcomeInfo) {
              this.$set(odd, 'outcomeInfo', data.outcomeInfo)
              this.$set(odd, 'liveOdd', data.outcomeInfo.odds)
            }
          } catch (e) {
            // Log o eventuale fallback
            console.warn('Errore ottenendo livescore per odd', odd, e)
          }
          //}
        })
        await Promise.all(liveOddsPromises)

        // 3. Gestione cashout come nel tuo modulo
        const cashoutResp = await cashoutPromise
        if (
          (typeof cashoutResp === 'object' && cashoutResp instanceof Error) ||
          !cashoutResp ||
          !cashoutResp.data
        ) {
          this.$set(this.betToShow, 'cashoutAvailable', false)
          this.$set(this.betToShow, 'cashoutTemporarilyUnavailable', false)
          this.$set(
            this.betToShow,
            'cashoutError',
            this.$t('cashout.errorText')
          )
          this.$set(this.betToShow, 'cashoutValue', null)
        } else if (
          cashoutResp.data.result === true &&
          cashoutResp.data.cashoutData
        ) {
          const updatedValue = cashoutResp.data.cashoutData.cashoutToConsider3
          this.$set(this.betToShow, 'cashoutValue', updatedValue)
          this.$set(this.betToShow, 'cashoutAvailable', true)
          this.$set(this.betToShow, 'cashoutTemporarilyUnavailable', false)
          this.$set(this.betToShow, 'cashoutError', null)
        } else {
          const errors =
            cashoutResp.data && cashoutResp.data.errors
              ? cashoutResp.data.errors
              : []
          const isDisabled =
            Array.isArray(errors) &&
            errors.some(
              e => (e.code || '').toUpperCase() === 'CASHOUT_DISABLED'
            )
          if (isDisabled) {
            this.$set(this.betToShow, 'cashoutAvailable', false)
            this.$set(this.betToShow, 'cashoutTemporarilyUnavailable', false)
            this.$set(this.betToShow, 'cashoutError', errors)
            this.$set(this.betToShow, 'cashoutValue', null)
          } else {
            this.$set(this.betToShow, 'cashoutAvailable', false)
            this.$set(this.betToShow, 'cashoutTemporarilyUnavailable', true)
            this.$set(
              this.betToShow,
              'cashoutError',
              errors.length > 0
                ? errors
                : this.$t('cashout.temporarilyUnavailable')
            )
            this.$set(this.betToShow, 'cashoutValue', null)
          }
        }
      } catch (error) {
        // Catch Generic
        this.$set(this.betToShow, 'cashoutAvailable', false)
        this.$set(this.betToShow, 'cashoutTemporarilyUnavailable', false)
        this.$set(this.betToShow, 'cashoutError', this.$t('cashout.errorText'))
        this.$set(this.betToShow, 'cashoutValue', null)
      }

      // 4. Aggiorna dett. e mostra dialog
      this.setDetailMyBet(this.betToShow)
      this.dialog = true
      this.overlay = false
      this.overlay_dialog_betlist = false
    },

    getWinning(bet) {
      switch (bet.type) {
        case 'single':
        case 'multiple':
          return (
            bet.currencySymbol +
            ' ' +
            parseFloat(bet._multiple_detail.winning_total).toFixed(2)
          )
        case 'integral':
          return (
            bet.currencySymbol +
            ' ' +
            parseFloat(bet._integral_detail.winning_total_max).toFixed(2)
          )
        case 'system':
          return (
            bet.currencySymbol +
            ' ' +
            parseFloat(bet._system_detail.winning_all_total).toFixed(2)
          )
      }
    },
    changeLiveMode(mode) {
      this.setLiveMode({ mode: mode })
    },
    sortby(array) {
      if (array.length > 0) {
        array = orderByLodash(array, ['source'], ['asc'])

        return array
      } else {
        return []
      }
    },
    result(type) {
      let response = type
      switch (type) {
        case 1:
          response = this.$t('statistics.corner')
          break
        case 6:
          response = this.$t('statistics.yellow')
          break
        case 7:
          response = this.$t('statistics.red')
          break
        case 8:
          response = this.$t('statistics.penalties')
          break
        case 9:
          response = this.$t('statistics.goal')
          break
        case 10:
          response = this.$t('statistics.substitutions')
          break
        case 24:
          response = this.$t('statistics.owngoal')
          break
        case 25:
          response = this.$t('statistics.penaltygoal')
          break
        case 40:
          response = this.$t('statistics.missedpenalty')
          break
        case 20:
          response = this.$t('statistics.aces')
          break
        case 21:
          response = this.$t('statistics.doublefaults')
          break
        case 34:
          response = this.$t('statistics.firstservewins')
          break
        case 12:
          response = this.$t('statistics.fouls')
          break
        case 28:
          response = this.$t('statistics.twopoints')
          break
        case 30:
          response = this.$t('statistics.threepoints')
          break
        case 31:
          response = this.$t('statistics.timeouts')
          break
        case 32:
          response = this.$t('statistics.freethrows')
          break
        case 33:
          response = this.$t('statistics.hits')
          break
      }
      return response
    },
    getSpecifiers(spec) {
      let result = ''

      if (spec.includes('#')) {
        const split = spec.split('#')
        if (split[1].includes(':')) {
          result = '(' + split[1] + ')'
        } else if (split[1].includes('(') && split[1].includes('.')) {
          result = ' [' + split[1] + '] '
        } else if (split[1] != '') {
          result = split[1]
        }

        if (_.size(split) > 2) {
          return result + ' ' + split[2]
        } else {
          return result
        }
      } else {
        return result
      }
    },
    getMatchCurrentTime(time) {
      if (time >= 0) {
        const minutes = Math.floor(time / 60)
        let seconds = time - minutes * 60
        seconds = parseFloat(bet.seconds).toFixed(2)
        if (seconds > 0) {
          if (seconds < 10) {
            return minutes + ':0' + seconds
          } else {
            return minutes + ':' + seconds
          }
        } else {
          return minutes
        }
      } else {
        return 0
      }
    },
    getResult(result, team) {
      if (team == 'home') {
        var point = _.find(result, { Position: '1' })
        return point ? +point.Value : 0
      } else if (team == 'away') {
        var point = _.find(result, { Position: '2' })
        return point ? +point.Value : 0
      } else {
        return 0
      }
    },
    async rebet(odds) {
      const now = new Date()
      this.dialog = false
      await this.resetCart()
      await this.setOddsInCart(odds)
      await this.setCreatedAtCart(now.getTime())
      await this.refreshCart()
      await this.$root.$emit('sectionCart')
    },
    async getLiveDate(eventSource, outcomeExternalId) {
      const data = await this.fetchEventResultAndTimeDetail({
        source: eventSource,
        outcomeExternalId: outcomeExternalId,
      })

      return data
    },

    handleClick(value) {
      this.openDetail(value)
    },

    async initialize() {
      this.currentPage = 1 // Resetta sempre all’avvio
      await this.reloadBets()
    },
    setupCashoutPolling() {
      this.clearCashoutPolling()
      const intervalMs =
        Math.max(Number(this.getCashoutApiPollIntervalSec), 60) * 1000
      this.cashoutIntervalId = setInterval(() => {
        this.reloadBets()
      }, intervalMs)
    },

    clearCashoutPolling() {
      if (this.cashoutIntervalId) {
        clearInterval(this.cashoutIntervalId)
        this.cashoutIntervalId = null
      }
    },

    async reloadBets() {
      if (this.apiLoading) return
      this.apiLoading = true
      this.loading = true
      await this.fetchMyBetsInProgressCashoutPaginated({
        all: false,
        betTypes: ['single', 'multiple'],
        page: this.currentPage,
        numPerPage: this.numPerPage,
      })
      await this.checkCashoutForPendingBets()
      this.loading = false
      this.apiLoading = false
    },
  },

  async mounted() {
    await this.initialize()
    this.setupCashoutPolling() // avvia polling
  },

  beforeDestroy() {
    this.clearCashoutPolling()
  },
}
</script>

<style scoped>
.text-count-mybets {
  font-size: 12px;
  font-weight: bold;
}

.v-dialog.v-dialog--datepicker.v-dialog--active {
  width: auto;
}

.datatable-mybets tr {
  cursor: pointer;
}

.v-dialog.modal-mybetlist.v-dialog--active {
  width: 100% !important;
}

.fs12 {
  font-size: 12px !important;
}

/* Custom Modal Overlay */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

/* Custom Modal Container */
.custom-modal-container {
  display: flex;
  justify-content: flex-end;
  min-height: 100%;
  box-sizing: border-box;
  padding: 20px;
}

/* Custom Modal Window */
.custom-modal {
  /*background: white;*/
  background: var(--bg-dark-color);
  color: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
  margin: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  animation: modalSlideIn 0.3s ease-out;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  position: relative !important;
  margin: 0 auto !important;
  height: 360px !important;
  max-height: 360px !important;
  min-height: 360px !important;
}

.statistics-title {
  font-weight: 700;
  margin: 8px 0 10px 0;
  font-size: 15px;
  color: #fff;
  letter-spacing: 0.2px;
  margin: 0px;
  padding: 0px;
  padding-left: 0px;
  padding-left: 2px;
}

.stats-list .stat-row-even {
  background: #f6f6f6;
}

.stats-list .stat-row-odd {
  background: #ececec;
}

.stat-label {
  font-weight: 600;
  color: #fff;
  font-size: 13px;
  width: 130px;
  display: inline-block;
  padding: 0px;
}

.stat-value {
  font-size: 12px;
  color: #fff;
  margin-left: 3px;
  padding: 0px;
}

.stat-value-extra {
  opacity: 0.75;
  margin-left: 8px;
  font-size: 12px;
}

.v-list-item {
  padding: 0 8px;
}
.v-list--dense .v-list-item .v-list-item__content,
.v-list-item--dense .v-list-item__content {
  padding: 0px;
}

.incid-title {
  font-weight: bold;
  color: #fff;
  margin: 18px 0 5px 0;
  font-size: 15px;
  letter-spacing: 0.2px;
}

.period-incidents {
  margin-bottom: 12px;
  border-bottom: 1px solid #ededed;
  padding-bottom: 4px;
}

.period-label {
  font-size: 12px;
  color: #fff;
  font-weight: bold;
  margin-bottom: 3px;
}

.inc-list .inc-row-even {
  background: #f7fafb;
}

.inc-list .inc-row-odd {
  background: #f0f4f5;
}

.inc-label {
  color: #087dfa;
  margin-right: 12px;
  font-weight: 600;
  font-size: 12px;
}

.inc-details {
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  margin-left: 6px;
}

.bet-console-prefix .modal-on-top .v-list-item .v-list-item__content {
  /*background: #959393;*/
}

/* Animazioni Modal */
@keyframes modalSlideIn {
  from {
    transform: translateX(30px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Modal Header */
.modal-header {
  padding: 16px;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
  background: var(--bg-dark-color);
  color: #fff;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #fff;
}

/* Modal Body */
.modal-body {
  padding: 20px;
  color: #fff;
  overflow-y: auto;
  flex-grow: 1;
  background: var(--bg-dark-color);
  color: #fff;
}

/* Modal Footer */
.modal-footer {
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid #eee;
  position: sticky;
  bottom: 0;
  background: white;
  background: var(--bg-dark-color);
  color: #fff;
}

/* Buttons */
.modal-confirm-btn {
  background: #3085d6;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}

.modal-confirm-btn:hover {
  background: #2670c0;
}

.modal-cancel-btn {
  background: #f0f0f0;
  color: #333;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}

.modal-cancel-btn:hover {
  background: #e0e0e0;
}

.cashout_preview.unavailable-state {
  background: #eee;
  color: #999;
  cursor: default;
  border: none;
  opacity: 0.9;
}

/* Responsive */
@media (max-width: 480px) {
  .custom-modal {
    width: 95%;

    height: 300px !important;
    max-height: 300px !important;
    min-height: 300px !important;
  }

  .modal-footer {
    flex-direction: column-reverse;
    gap: 8px;
  }

  .modal-confirm-btn,
  .modal-cancel-btn {
    width: 100%;
  }
}

.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 70%;
}

.stat-grid {
  width: 100%;
  margin-top: 8px;
  border-radius: 10px;
  background: #26252e;
  overflow-x: auto;
}
.stat-grid-row {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #33313b;
}
.stat-grid-header {
  font-weight: 700;
  font-size: 13px;
  color: #82b1ff;
  background: #23202f !important;
}
.stat-grid-cell {
  flex: 1 1 0;
  min-width: 90px;
  max-width: 18vw;
  padding: 10px 6px 9px 7px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12.5px;
  background: #282742;
  border-right: 1px solid #33313b;
}
.stat-grid-header-cell {
  background: #23202f;
  font-size: 13px;
  font-weight: bold;
  color: #82b1ff;
  border-bottom: 1.5px solid #487fd0;
}
.stat-grid-row:last-child {
  border-bottom: none;
}
.stat-grid-value-cell {
  color: #fff;
  font-weight: bold;
  background: #23202f;
}
.stat-grid-value-cell:nth-child(even) {
  background: #25223c;
}
@media (max-width: 600px) {
  .stat-grid-cell {
    min-width: 57px;
    font-size: 12px;
  }
  .stat-grid-header-cell {
    font-size: 12px;
  }
}

.inc-grid {
  width: 100%;
  margin-top: 2px;
  border-radius: 10px;
  background: #25213b;
  overflow-x: auto;
}
.inc-grid-row {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #33313b;
}
.inc-grid-header {
  font-weight: 700;
  font-size: 13px;
  color: #ffd700;
  background: #1d1930 !important;
}
.inc-grid-cell {
  flex: 1 1 0;
  min-width: 90px;
  max-width: 19vw;
  padding: 10px 6px 9px 7px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background: #282742;
  border-right: 1px solid #33313b;
  font-size: 13px;
}
.inc-grid-header-cell {
  background: #1d1930;
  font-size: 13px;
  font-weight: bold;
  color: #ffd700;
  border-bottom: 1.5px solid #e1af28;
  text-transform: capitalize;
}
.inc-grid-value-cell {
  color: #fff;
  font-weight: 600;
  background: #23202f;
}
.inc-grid-value-cell:nth-child(even) {
  background: #302b43;
}
.inc-label {
  color: #16a9ec;
  font-weight: 700;
}
.inc-val {
  margin-left: 4px;
  color: #fff;
  font-weight: 600;
}
.inc-sec {
  margin-left: 4px;
  color: #ccc;
  font-size: 11px;
}

.my-frozen-loader {
  animation: myFrozenLoaderPulse 1.3s infinite;
}
@keyframes myFrozenLoaderPulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  60% {
    transform: scale(1.18);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.btn-cashout-mobile {
  width: 98%;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 40px;
}
.mybets-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 18px 0 8px 0;
  gap: 4px;
  padding-bottom: 18px;
}

.mybets-pagination button {
  background: #23202f;
  color: #fff;
  border: 1px solid #33313b;
  min-width: 32px;
  margin: 0 2px;
  border-radius: 3px;
  font-size: 14px;
  padding: 3px 9px;
  cursor: pointer;
  transition: background 0.15s;
}

.mybets-pagination button.active,
.mybets-pagination button:active {
  background: #a0c528;
  color: #23202f;
  font-weight: bold;
}

.mybets-pagination button:disabled {
  opacity: 0.55;
  cursor: default;
}

.mybets-pagination button.active {
  background: var(--primary-color);
  color: #fff;
  font-weight: bold;
}

.mybets-pagination button:not(:disabled):hover {
  background: var(--primary-color);
  color: #fff;
}

/* Questo fa sì che .active prevale sempre anche in hover */
.mybets-pagination button.active:hover {
  background: var(--primary-color);
  color: #fff;
}
</style>

<!-- TODO REFACTOR ME PLEASE -->
